import React from 'react';
import styled from 'styled-components';

const Button = styled.a`
  font-weight: ${props => (props.secondary ? '400' : '600')};
  cursor: pointer;
  font-size: 15px;
  background: none;
  border: none;
  text-decoration: none;
  font-family: ${props => props.theme.primaryFontFontFamily};
  border-radius: 17.5px;
  padding: 7px 16px;
  color: ${props => props.theme.orderStatusTrackTextColor};
  background: ${props => props.theme.orderStatusTrackBackgroundColor};

  @media (max-width: 480px) {
    padding: 3px 8px;
  }
`;

const TrackButton = props => {
  return (
    <div>
      <Button
        id="TrackButton"
        href={props.orderStatus.delivery_tracking_url}
        target="_blank"
        onClick={e => e.stopPropagation()}
      >
        Track Your Driver
      </Button>
    </div>
  );
};

export default TrackButton;
